const dummy_t = (translationKey) => translationKey;

export default [
  {
    externalPath: {
      'cs-CZ': 'https://dietaoxy.pl/cz',
      'pl-PL': 'https://dietaoxy.pl/',
    },
    translationKey: dummy_t('menu.blog'),
  },
  {
    path: '/knowledge',
    translationKey: dummy_t('menu.knowledge'),
  },
  {
    externalPath: {
      'en-US': 'https://maxxnationen.zendesk.com/hc/en-us',
      'pl-PL': 'https://maxxnation.zendesk.com/hc/pl',
    },
    translationKey: dummy_t('footer.contact'),
  },
];
